import classes from './styles.module.css';
import mail from '../../../assets/images/mail.svg';
import LoginLayout from '../../../components/LoginLayout';

function PasswordResetMail() {
  return (
    <LoginLayout
      title="パスワード再設定"
      titleHeightIsTheSameAsLogo
      goBack="login"
    >
      <div className={classes.MailImg}>
        <img src={mail} />
      </div>
      <div className={classes.BoldComment}>
        メールを
        <wbr />
        確認してください
      </div>
      <div className={classes.Comment}>
        認証メールを送信しました。
        <br />
        メール本文に記載されている
        <wbr />
        認証URLをクリックし、
        <br />
        変更を完了してください。
      </div>
    </LoginLayout>
  );
}

export default PasswordResetMail;
